// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36jBK","right":"styles_right__JwEDm"};